import * as models from './model';
import { IOrder } from './model';
export interface IOrderMain {
    pagination?: models.IPaginationResponse;
    values?: models.IOrder[];
}
